<template>
  <v-dialog
    :value="isOpen"
    max-width="800"
    @input="close()"
  >
    <debt-wizard ref="debtWizardDialog" :household="household" @on-save="updateSavedDebt" />
    <v-card>
      <v-card-title class="text-center title justify-center">Choose a Debt or add a new one</v-card-title>
      <v-card-text>
        <v-row class="justify-center">
          <v-col
            v-for="debt in debtsSorted"
            :key="'debtChooser' + debt.id"
            cols="12"
            sm="6"
          >
            <debt-card
              :debt="debt"
              hide-delete
              @on-click="selectDebt(debt)"
              :as-of="asOf"
            />
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="6">
            <debt-card 
              :debt="{}" 
              @on-click="$refs.debtWizardDialog.open()"
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DebtCard from '@/views/households/liabilities/Card'
import DebtWizard from '@/views/households/liabilities/DebtWizard'

export default {
  name: 'SelectDebtDialog',
  props: {
    household: {
      type: Object,
      required: true
    },
    ignoreDebts: {
      type: Array,
      default: () => []
    },
    asOf: String
  },
  components: {
    DebtCard,
    DebtWizard
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    debtsSorted() {
      let debts = JSON.parse(JSON.stringify(this.household.debts))
      debts = debts.filter(d => {

        return (!this.ignoreDebts.includes((d.id + '')) && !this.ignoreDebts.includes(parseInt(d.id)))
      })
      debts.sort((a,b) => parseInt(b.balance) - parseInt(a.balance))
      return debts
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    },
    selectDebt(debt) {
      this.$emit('on-select', debt)
      this.close()
    },
    updateSavedDebt (debt) {
      this.$emit('on-debt-updated', debt)
      this.$emit('on-select', debt)
      this.close()
    }
  }
}
</script>